/**
 * Created by pandemio on 10/16/18.
 */
import React from "react";
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';

// Be sure to include styles at some point, probably during your bootstraping
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../../../translations/global.json"
import LanguageManager from '../../../custom-classes/language-manager';
/** End of Multiple Language imports **/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags, faDesktop, faSignInAlt, faSignOutAlt, faHeadset, faMoneyCheck, faShoppingBasket, faIdCardAlt, faPrint, faUsers, faLock } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom";
import SessionManager from "../../../custom-classes/session-manager";
import ModalCouponManager from '../../modals/modal-coupon-manager';

class NavbarDesktop extends React.Component {
    constructor(props) {
        super(props);

        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage() }
        });

        this.state = {
            sidebarOpen: true,
            isLoggedIn: SessionManager.getSessionEmployee() != null && SessionManager.getSessionEmployee().length > 0
        };
        this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);

        this.props.addTranslation(global);
    }

    onSetSidebarOpen(open) {
        this.setState({ sidebarOpen: open });
    }

    render() {
        return (
            <SideNav className="sidebar-landing"
                onSelect={(selected) => {
                    // Add your code here
                }}
            >
                <SideNav.Toggle />
                <SideNav.Nav>
                    {
                        this.state.isLoggedIn ?
                            <NavItem eventKey="dashboard">
                                <NavIcon>
                                    <NavLink to="/dashboard-employee" className="navbar-button">
                                        <FontAwesomeIcon icon={faDesktop} style={{ fontSize: '1.75em' }} />
                                    </NavLink>
                                </NavIcon>
                                <NavText>
                                    <NavLink to="/dashboard-employee" className="navbar-button">
                                        <Translate id="employee-navbar.dashboard" options={{renderInnerHtml: true}}/>
                                    </NavLink>
                                </NavText>
                            </NavItem> : null
                    }
                    {
                        !this.state.isLoggedIn ?
                            <NavItem eventKey="login">
                                <NavIcon>
                                    <NavLink to="/login-employee" className="navbar-button">
                                        <FontAwesomeIcon icon={faSignInAlt} style={{ fontSize: '1.75em' }} />
                                    </NavLink>
                                </NavIcon>
                                <NavText>
                                    <NavLink to="/login-employee" className="navbar-button">
                                        <Translate id="employee-navbar.login" options={{renderInnerHtml: true}}/>
                                    </NavLink>
                                </NavText>
                            </NavItem> : null
                    }
                    { /*
                        this.state.isLoggedIn ?
                            <NavItem eventKey="chatrooms">
                                <NavIcon>
                                    <NavLink to="/chatroom" className="navbar-button">
                                        <FontAwesomeIcon icon={faHeadset} style={{ fontSize: '1.75em' }} />
                                    </NavLink>
                                </NavIcon>
                                <NavText>
                                    <NavLink to="/chatroom" className="navbar-button">
                                        <Translate id="employee-navbar.chatroom" options={{renderInnerHtml: true}}/>
                                    </NavLink>
                                </NavText>
                            </NavItem> : null */
                    }
                    {
                        this.state.isLoggedIn ?
                            <NavItem eventKey="coupons">
                                <NavIcon>
                                    <NavLink to="/coupons" className="navbar-button">
                                        <FontAwesomeIcon icon={faTags} style={{ fontSize: '1.75em' }} />
                                    </NavLink>
                                </NavIcon>
                                <NavText>
                                    <NavLink to="/coupons" className="navbar-button">
                                        <Translate id="employee-navbar.coupons" options={{renderInnerHtml: true}}/>
                                    </NavLink>
                                </NavText>
                            </NavItem> : null
                    }
                    {
                        this.state.isLoggedIn ?
                            <NavItem eventKey="plans-search">
                                <NavIcon>
                                        <FontAwesomeIcon icon={faMoneyCheck} style={{ fontSize: '1.75em' }} />
                                </NavIcon>
                                <NavText>
                                        <Translate id="employee-navbar.plans" options={{renderInnerHtml: true}}/>
                                </NavText>
                                <NavItem eventKey="plans/add" className="card-red">
                                    <NavText>
                                        <NavLink to="/plans-manager" className="white-text">
                                            <Translate id="employee-navbar.plans-add" options={{renderInnerHtml: true}}/>
                                        </NavLink>
                                    </NavText>
                                </NavItem>
                                <NavItem eventKey="plans/update" className="card-red">
                                    <NavText>
                                        <NavLink to="/plans-search" className="white-text">
                                            <Translate id="employee-navbar.plans-update" options={{renderInnerHtml: true}}/>
                                        </NavLink>
                                    </NavText>
                                </NavItem>
                            </NavItem> : null
                    }


                    {
                        this.state.isLoggedIn ?
                            <NavItem eventKey="subscriptions-search" >
                                <NavIcon>
                                    <FontAwesomeIcon icon={faIdCardAlt} style={{ fontSize: '1.75em' }} />
                                </NavIcon>
                                <NavText>
                                    <Translate id="employee-navbar.subscriptions" options={{renderInnerHtml: true}}/>
                                </NavText>
                                <NavItem eventKey="subscriptions/add" className="card-red">
                                    <NavText>
                                        <NavLink to="/subscription-manager" className="white-text">
                                            <Translate id="employee-navbar.subscriptions-add" options={{renderInnerHtml: true}}/>
                                        </NavLink>
                                    </NavText>
                                </NavItem>
                                <NavItem eventKey="subscriptions/update" className="card-red">
                                    <NavText>
                                        <NavLink to="/subscriptions-search" className="white-text">
                                            <Translate id="employee-navbar.subscriptions-update" options={{renderInnerHtml: true}}/>
                                        </NavLink>
                                    </NavText>
                                </NavItem>
                            </NavItem> : null
                    }

                    {
                        this.state.isLoggedIn ?

                            <NavItem eventKey="products-search" >
                                <NavIcon>
                                    <FontAwesomeIcon icon={faShoppingBasket} style={{ fontSize: '1.75em' }} />
                                </NavIcon>
                                <NavText>
                                    <Translate id="employee-navbar.products" options={{renderInnerHtml: true}}/>
                                </NavText>
                                <NavItem eventKey="products/add" className="card-red">
                                    <NavText>
                                        <NavLink to="/products-add" className="white-text">
                                            <Translate id="employee-navbar.products-add" options={{renderInnerHtml: true}}/>
                                        </NavLink>
                                    </NavText>
                                </NavItem>
                                <NavItem eventKey="products/update" className="card-red">
                                    <NavText>
                                        <NavLink to="/products-search" className="white-text">
                                            <Translate id="employee-navbar.products-update" options={{renderInnerHtml: true}}/>
                                        </NavLink>
                                    </NavText>
                                </NavItem>
                            </NavItem> : null
                    }

                    {
                        this.state.isLoggedIn ?
                            <NavItem eventKey="reports">
                                <NavIcon>
                                    <NavLink to="/reports" className="navbar-button">
                                        <FontAwesomeIcon icon={faPrint} style={{ fontSize: '1.75em' }} />
                                    </NavLink>
                                </NavIcon>
                                <NavText>
                                    <NavLink to="/reports" className="navbar-button">
                                        <Translate id="employee-navbar.reports" options={{renderInnerHtml: true}}/>
                                    </NavLink>
                                </NavText>
                            </NavItem> : null
                    }

                    {
                        this.state.isLoggedIn ?
                            <NavItem eventKey="users-search">
                                <NavIcon>
                                    <NavLink to="/users-search" className="navbar-button">
                                        <FontAwesomeIcon icon={faUsers} style={{ fontSize: '1.75em' }} />
                                    </NavLink>
                                </NavIcon>
                                <NavText>
                                    <NavLink to="/users-search" className="navbar-button">
                                        <Translate id="employee-navbar.manage-users" options={{renderInnerHtml: true}}/>
                                    </NavLink>
                                </NavText>
                            </NavItem> : null
                    }

                    {
                        this.state.isLoggedIn ?
                            <NavItem eventKey="roles-manager">
                                <NavIcon>
                                    <NavLink to="/roles-manager" className="navbar-button">
                                        <FontAwesomeIcon icon={faLock} style={{ fontSize: '1.75em' }} />
                                    </NavLink>
                                </NavIcon>
                                <NavText>
                                    <NavLink to="/roles-manager" className="navbar-button">
                                        <Translate id="employee-navbar.roles" options={{renderInnerHtml: true}}/>
                                    </NavLink>
                                </NavText>
                            </NavItem> : null
                    }

                    {
                        this.state.isLoggedIn ?
                            <NavItem eventKey="logout">
                                <NavIcon>
                                    <NavLink to="/login-employee" className="navbar-button">
                                        <FontAwesomeIcon icon={faSignOutAlt} style={{ fontSize: '1.75em' }} />
                                    </NavLink>
                                </NavIcon>
                                <NavText>
                                    <NavLink to="/login-employee" className="navbar-button">
                                        <Translate id="employee-navbar.logout" options={{renderInnerHtml: true}}/>
                                    </NavLink>
                                </NavText>
                            </NavItem> : null
                    }


                </SideNav.Nav>
            </SideNav>
        );
    }
}

export default withLocalize(NavbarDesktop);